<template>
    <BModal ref="modal" :title="$t('nvrChannels.title')" centered scrollable no-close-on-backdrop header-class="modal-title" modal-class="no-border-modal" @hidden="onHidden">
        <p v-if="channels.length === 0" class="mb-0">{{ $t('nvrChannels.none') }}</p>
        <template v-else>
            <div class="form-check mb-2">
                <input id="nvr-channels-all" class="form-check-input" type="checkbox" :checked="allSelected" @change="selectAll($event.target.checked)">
                <label class="form-check-label fw-bold text-muted" for="nvr-channels-all">{{ $t('video.selectAll') }}</label>
            </div>
            <hr class="my-2">
            <div v-for="channel in channels" :key="channel.channel" class="form-check mb-2">
                <input :id="`nvr-channel-${channel.channel}`" class="form-check-input" type="checkbox" :value="channel.channel" v-model="selected">
                <label class="form-check-label" :for="`nvr-channel-${channel.channel}`">
                    <span class="fw-bold text-primary">{{ channel.label }}</span>
                    <span class="d-block font-13 text-muted">{{ description(channel) }}<span v-if="channel.online != null" :class="channel.online ? 'text-success' : 'text-danger'"> - {{ channel.online ? $t('common.active') : $t('common.inactive') }}</span></span>
                </label>
            </div>
        </template>
        <template #footer>
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="close(null)">{{ $t('common.cancel') }}</button>
                <button type="button" class="btn btn-primary ms-2" @click="close(selectedChannels)">{{ $t('common.ok') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Channels reported by the probe of a new NVR: the installer picks the cameras to declare.
// show() resolves with the selected channels (possibly empty), or null when cancelled.
export default {
    name: 'NvrChannelsModal',
    components: {
        BModal
    },
    setup() {
        const { t } = useI18n();
        const modal = ref(null);
        const channels = ref([]);
        const selected = ref([]);
        let resolver = null;

        const show = (probedChannels) => {
            channels.value = probedChannels;
            // Every channel is selected, except the ones the NVR reports offline
            selected.value = probedChannels.filter(c => c.online !== false).map(c => c.channel);
            modal.value.show();
            return new Promise(resolve => { resolver = resolve; });
        };

        const close = (result) => {
            const resolve = resolver;
            resolver = null;
            modal.value.hide();
            if (resolve) resolve(result);
        };

        const onHidden = () => {
            if (resolver) close(null);
        };

        const allSelected = computed(() => selected.value.length === channels.value.length);

        const selectAll = (value) => {
            selected.value = value ? channels.value.map(c => c.channel) : [];
        };

        const selectedChannels = computed(() => channels.value.filter(c => selected.value.includes(c.channel)));

        const description = (channel) => {
            const parts = [t('video.channelLabel', { channel: channel.channel })];
            const stream = channel.subStream ?? channel.mainStream;
            if (stream && stream.description) parts.push(stream.description);
            return parts.join(' - ');
        };

        return {
            modal,
            channels,
            selected,
            allSelected,
            selectAll,
            selectedChannels,
            description,
            show,
            close,
            onHidden,
        };
    }
}
</script>
